import * as React from 'react';
import { InlineText1 } from '@cian/ui-kit/typography';

import * as styles from './styles.css';

interface IProps {
  onClick(): void;
}

export function NewbuildingConsultantInFilter({ onClick }: IProps) {
  return (
    <div className={styles['container']}>
      <div className={styles['title']}>
        <InlineText1 fontWeight="bold">Быстро найти квартиру мечты в новостройке</InlineText1>
        <br />
        <InlineText1 color="gray60_100">Мы подберем для вас индивидуальные предложения.&nbsp;</InlineText1>
        <div className={styles['link']}>
          <InlineText1 color="primary_100" onClick={onClick}>
            Узнать больше
          </InlineText1>
        </div>
      </div>
      <div className={styles['consultant-img']} />
    </div>
  );
}
